import { IChartDataAndActions } from '@/creditflowresearch/domain/vo/Bond/IChartDataAndActions';
import { Periods } from '@/creditflowresearch/ui/common/constants';
import { IHeaderConfig } from '@/creditflowresearch/ui/common/components/FinsightChart/HeaderChart/IHeaderConfig';
import { ChartsGrouping, ChartType, SectorGrouping } from '@/creditflowresearch/application/Bonds/charts/constants';
import { IToggleGroup } from '@/creditflowresearch/ui/common/components/FinsightChart/HeaderChart/IToggleGroup';

const getTitleOfChart = (isSector: boolean, sectorGrouping: SectorGrouping, grouping: ChartsGrouping): string => {
  const sectorTitle = sectorGrouping === SectorGrouping.SECTOR ? 'Sector' : 'Top Subsector';
  const dealerTitle = 'Broker-Dealer';
  const groupingChartTitle = grouping === ChartsGrouping.VOLUME ? 'Volume' : 'Trade Count';

  return `${ isSector ? sectorTitle : dealerTitle } ${ groupingChartTitle }`;
};

export default ({
  period,
  chartType,
  grouping,
  isSector,
  sectorGrouping,
  actions: { onChangeChartType, onChangePeriod, onChangeGrouping, onChangeSector },
}: IChartDataAndActions): IHeaderConfig => {
  const groups: IToggleGroup[] = [
    {
      dataTest: 'groupVolumeCount',
      value: grouping,
      onChange: (value: string) => onChangeGrouping(value as ChartsGrouping),
      options: [
        { value: ChartsGrouping.VOLUME, title: 'Volume', dataTest: 'volumeBtn' },
        { value: ChartsGrouping.COUNT, title: 'Count', dataTest: 'countBtn' },
      ],
    },
    {
      dataTest: 'groupPeriod',
      value: period,
      onChange: (value: string) => onChangePeriod(value as Periods),
      options: [
        { value: Periods.MONTH, title: 'Month', dataTest: 'monthBtn' },
        { value: Periods.QUARTER, title: 'Quarter', dataTest: 'quarterBtn' },
        { value: Periods.YEAR, title: 'Year', dataTest: 'yearBtn' },
      ],
    },
    {
      dataTest: 'groupGroupedStacked',
      value: chartType,
      onChange: (value: string) => onChangeChartType(value as ChartType),
      options: [
        { value: ChartType.GROUPED, title: `Grouped ${ grouping === ChartsGrouping.VOLUME ? '$' : '#' }`, dataTest: 'groupedBtn' },
        { value: ChartType.STACKED, title: 'Stacked %', dataTest: 'stackedBtn' },
      ],
    },
  ];

  if (isSector) {
    groups.unshift({
      dataTest: 'groupSector',
      value: sectorGrouping,
      onChange: (value: string) => onChangeSector(value as SectorGrouping),
      options: [
        { value: SectorGrouping.SECTOR, title: 'Sector', dataTest: 'sectorBtn' },
        { value: SectorGrouping.SUB_SECTOR, title: 'Subsector', dataTest: 'subsectorBtn' },
      ],
    });
  }

  return {
    title: getTitleOfChart(isSector, sectorGrouping, grouping),
    groups,
  };
};
